import { render, staticRenderFns } from "./AppArcSelector.vue?vue&type=template&id=5c1953d2&scoped=true&"
import script from "./AppArcSelector.vue?vue&type=script&lang=ts&"
export * from "./AppArcSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppArcSelector.vue?vue&type=style&index=0&id=5c1953d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1953d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
